export default __webpack_public_path__ + "static/plp--anejo-16fd1a1f92e0c0bf0794c0b67968ebc0.jpg";